import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { postRequest, putRequest } from '../../requestUtils';
import './ConsultantAgreementModal.scss';
import cloraLogo from '../../../assets/images/Logo_Gray.svg';
var ConsultantAgreementModal = /*#__PURE__*/function (_Component) {
  function ConsultantAgreementModal(props) {
    var _this;
    _classCallCheck(this, ConsultantAgreementModal);
    _this = _callSuper(this, ConsultantAgreementModal, [props]);
    _this.state = {
      showModal: props.showModal,
      agreeCheckbox: false
    };
    _this.handleToggleCheckbox = _this.handleToggleCheckbox.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleCallback = _this.handleCallback.bind(_this);
    return _this;
  }
  _inherits(ConsultantAgreementModal, _Component);
  return _createClass(ConsultantAgreementModal, [{
    key: "handleToggleCheckbox",
    value: function handleToggleCheckbox() {
      var agreeCheckbox = this.state.agreeCheckbox;
      this.setState({
        agreeCheckbox: !agreeCheckbox
      });
    }
  }, {
    key: "handleCallback",
    value: function handleCallback() {
      var _this2 = this;
      var _this$props = this.props,
        submitUrl = _this$props.submitUrl,
        submitMethod = _this$props.submitMethod,
        csrfToken = _this$props.csrfToken;
      if (submitMethod === 'get') {
        this.setState({
          showModal: false
        });
        window.location = submitUrl;
      } else {
        postRequest(submitUrl, {}, csrfToken, 'text').then(function (response) {
          _this2.setState({
            showModal: false
          });
          window.location = response.data.redirect_url;
        })["catch"](function () {
          _this2.setState({
            flashMessage: 'There was an error creating the proposal.'
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props2 = this.props,
        consultantProfileId = _this$props2.consultantProfileId,
        agreementVersion = _this$props2.agreementVersion,
        csrfToken = _this$props2.csrfToken;
      putRequest("/consultant_profiles/".concat(consultantProfileId), {
        signed_cra_version: agreementVersion
      }, csrfToken).then(this.handleCallback)["catch"](function () {
        _this3.setState({
          flashMessage: 'There was an error submitting the agreement.'
        });
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      // Consultant does not agree
      var cancelUrl = this.props.cancelUrl;
      this.setState({
        showModal: false
      });
      if (cancelUrl) {
        window.location = cancelUrl;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state = this.state,
        showModal = _this$state.showModal,
        agreeCheckbox = _this$state.agreeCheckbox,
        flashMessage = _this$state.flashMessage;
      var _this$props3 = this.props,
        agreementText = _this$props3.agreementText,
        buttonText = _this$props3.buttonText,
        buttonClass = _this$props3.buttonClass,
        buttonPrefix = _this$props3.buttonPrefix;
      return /*#__PURE__*/React.createElement(Fragment, null, buttonText && /*#__PURE__*/React.createElement("a", {
        className: "cra-button ".concat(buttonClass),
        onClick: function onClick() {
          return _this4.setState({
            showModal: true
          });
        },
        role: "button",
        tabIndex: 0,
        id: "cra-modal"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: buttonPrefix
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-white"
      }, buttonText)), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleClose,
        dialogClassName: "cra-confirm-modal",
        size: "xl"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "style-guide padded-modal-content"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Clora Consultant Referral Agreement (CRA)", /*#__PURE__*/React.createElement("img", {
        src: cloraLogo,
        alt: "clora logo",
        className: "brand-img float-right",
        height: 30,
        width: 75
      })), flashMessage, /*#__PURE__*/React.createElement("div", {
        className: "pt-3 body-text-2 agreement-text"
      }, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: agreementText
        }
      })), /*#__PURE__*/React.createElement("label", {
        htmlFor: "agree-checkbox",
        className: "custom-checkbox-container agree-checkbox-label"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "agree-checkbox",
        onChange: this.handleToggleCheckbox
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, "Yes, I understand and agree to the Clora Consultant Referral Agreement"))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleClose
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit,
        disabled: !agreeCheckbox
      }, "Next")))));
    }
  }]);
}(Component);
ConsultantAgreementModal.propTypes = {
  agreementText: PropTypes.string.isRequired,
  agreementVersion: PropTypes.string.isRequired,
  submitUrl: PropTypes.string.isRequired,
  submitMethod: PropTypes.string,
  cancelUrl: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonPrefix: PropTypes.string,
  consultantProfileId: PropTypes.string.isRequired
};
ConsultantAgreementModal.defaultProps = {
  buttonText: null,
  buttonClass: '',
  buttonPrefix: '',
  showModal: false,
  cancelUrl: null,
  submitMethod: 'post'
};
export default ConsultantAgreementModal;